module.exports = __webpack_public_path__ + "static/img/img_reward7.e413d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_reward7.png
// module id = adgR
// module chunks = 0